const CONST = {
  get CONFIG() {
    const token = sessionStorage.getItem("token") || "";
    return {
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Token": token,
        "accesstoken": token,
      },
    };
  },

  POLICY_STATUS: {
    PENDING: 'pending',
    COMPLETED: 'completed',
    PAID: 'completed-policy'
  },

  QUOTATION: {
    CLIENT_TYPE: {
      INDIVIDUAL: 'INDIVIDUAL',
      CORPORATE: 'CORPORATE'
    }
  }
  

};

export { CONST };